<div class="topbar" >
    <div class="layout-topbar">
        <div class="topbar-start">
            <!-- <div class="logo">
                <img [routerLink]="'/projects'" src="/assets/images/logo/logo.png">
            </div> -->
            <div class="text-600 text-4xl" style="font-weight: 800;">
              {{'LABEL.MAIN_SERVICE_NAME' | translate}}
            </div>
            <!-- <button type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
                <i class="pi pi-bars"></i>
            </button> -->

            <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>

        </div>

        <div class="topbar-end">
            <ul class="topbar-menu">
                <li class="topbar-search" >
                    <ng-container *ngIf="router.url.includes('projects'); else elseTemplate">
                        <button *ngIf="(['canAdmin', 'editProjects'] | hasPermissions)" pButton pRipple type="button" [label]="'LABEL.SETTINGS' | translate" icon="pi pi-cog" class="p-button-secondary p-button-text" [routerLink]="'settings'"></button>
                    </ng-container>
                    <ng-template #elseTemplate>
                        <button pButton pRipple type="button" [label]="'LABEL.PROJECTS' | translate" icon="pi pi-sitemap" class=" p-button-secondary p-button-text" [routerLink]="'projects'"></button>
                    </ng-template>


                    <!-- <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Search" class="w-12rem sm:w-full">
                    </span> -->
                </li>
                <li class="topbar-profile" *ngIf="appService.user$ | async; let user">
                    <button type="button" class="p-link" (click)="onProfileButtonClick()">
                        <div class="flex ">
                            <ngx-avatars [gravatarId]="user.email" [name]="user.displayName" [style]="customStyle"></ngx-avatars>
                        </div>
                    </button>

                </li>
                <li class="topbar-languages">
                    <p-dropdown appendTo="body"  styleClass="p-inputtext-sm "
                      [(ngModel)]="appService.language"
                      [options]="appService.languages"
                      optionLabel="name"
                      optionValue="id"
                      [filter]="false" filterBy="name">
                    </p-dropdown>
                </li>
            </ul>
        </div>
    </div>
</div>
